export default __webpack_public_path__ + "img/web-hour-89223176.png";